import { resolveGroupedTabs } from "app/constants/tabConstants";
import { ResidentTabPanel } from "app/features/navigation/templates/ResidentTabPanel";
import { useLocalSearchParams, usePathname } from "expo-router";
import { View } from "react-native";
import { useResidentContext } from "../../provider/ResidentProvider";
import { ResidentProfileAvatar } from "app/components/atoms/ResidentProfileAvatar";
import { ResidentLayoutProvider } from "../../provider/ResidentLayoutProvider";

interface Props {
  children: React.ReactNode;
  hideTabs?: boolean;
}

export function ResidentPanelTemplate({ children, hideTabs }: Props) {
  const pathname = usePathname();
  const { id } = useLocalSearchParams();
  const residentId = id as string;

  const groupedTabs = resolveGroupedTabs(residentId);

  const { resident } = useResidentContext();

  return (
    <View className="flex-1 bg-white">
      <ResidentLayoutProvider
        contentContainerClassName="p-dashboard !pb-20"
        stickyHeaderIndices={[0]}
      >
        <View className="bg-white -mt-1 pt-1 pb-2">
          <ResidentProfileAvatar resident={resident} />
        </View>
        <ResidentTabPanel
          tabs={groupedTabs}
          currentPath={pathname}
          hideTabs={hideTabs}
        />
        {children}
      </ResidentLayoutProvider>
    </View>
  );
}
